import {
    LogOtelService,
    LogOtelUtilsService,
    LogOtelSpanProcessorService,
    ILogOtelConfig,
} from './otel';

export function otelLogFactory(config: ILogOtelConfig): LogOtelService {
    const utils: LogOtelUtilsService = new LogOtelUtilsService(
        new LogOtelSpanProcessorService(),
        config,
    );
    utils.initialize();
    
    const service = new LogOtelService(utils);

    return service;
}
